// if base rate variant is HOURLY, append hourly rate and hours to label
export const renderBaseRateFieldLabel = (
  hourlyBaseRate: number,
  hourlyBaseRateHours: number,
  currencyFormatter: (amount: number) => string
) => {
  if (!!hourlyBaseRate && !!hourlyBaseRateHours) {
    const hourLabel = hourlyBaseRateHours === 1 ? "Hour" : "Hours";
    return `Base Rate (${currencyFormatter(
      hourlyBaseRate
    )} * ${hourlyBaseRateHours} ${hourLabel})`;
  }
  return "Base Rate";
};
